import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Sound from 'react-sound';
import { ReactSVG } from 'react-svg';

import {
  getListManagerOrder,
  getOrderDetail,
} from '../../../../pages/Order/OrderManagement/actions';
import {
  removeNotificationBell,
  setCurrentRestaurant,
  setRingBell,
  setViewedNotification,
} from '../../../../pages/Setting/actions';
import { isEmpty, isEmptyObject } from '../../../../utils/utils';
import {
  EnumBellSound,
  EnumNotificationBell,
  EnumPage,
} from '../../../../constants/enum';

import NotificationDropdown from './NotificationDropdown';
import { getListIds } from '../../../../pages/Table/TableManagement/actions';
import {
  changeFilters,
  openDialogGeneric,
} from '../../../../redux/genericAction';
import { changeCurrentRestaurantNowShip } from '../../../../pages/NowShip/actions';

import normalSoundFile from '../../../../assets/common/audio/notification.mp3';
import assignTimeoutSoundFile from '../../../../assets/common/audio/assignTimeout.mp3';

import BellSvgIcon from '../../../../assets/common/svg/bell.svg'

// This line remove console on dev mode
window.soundManager.setup({ debugMode: false });

function getBellSoundFile(bellSoundId) {
  switch (bellSoundId) {
    case EnumBellSound.NORMAL.id: {
      return normalSoundFile;
    }
    case EnumBellSound.NOW_SHIP_ASSIGN_TIMEOUT.id: {
      return assignTimeoutSoundFile;
    }
    default: {
      return normalSoundFile;
    }
  }
}

class NotificationBell extends React.PureComponent {
  state = {
    isDropdownNotificationOpen: false,
  };

  handleSelectNotification = (restaurant, notification) => {
    const { removeNotificationBellConnect } = this.props;
    const { orderCode, type } = notification;
    switch (type) {
      case EnumNotificationBell.ORDER.id: {
        this.processNotificationOrder(restaurant, notification);
        break;
      }
      case EnumNotificationBell.TABLE.id: {
        this.processNotificationTable(restaurant, notification);
        break;
      }

      default: {
        break;
      }
    }

    this.setState({
      isDropdownNotificationOpen: false,
    });
    removeNotificationBellConnect(orderCode);
  };

  processNotificationOrder = (restaurant, notification) => {
    const typePushOrder = EnumNotificationBell.ORDER;
    const {
      setCurrentRestaurantConnect,
      getListManagerOrderConnect,
      getOrderDetailConnect,
      history,
      location,
    } = this.props;
    const { orderCode } = notification;
    const { pathname } = location;
    if (!isEmptyObject(restaurant)) {
      setCurrentRestaurantConnect(restaurant);
    }
    if (pathname !== typePushOrder.to) {
      history.push(typePushOrder.to);
    } else {
      getListManagerOrderConnect();
    }
    getOrderDetailConnect(orderCode);
  };

  processNotificationTable = (restaurant, notification) => {
    const typePushTable = EnumNotificationBell.TABLE;
    const {
      handleChangeFiltersConnect,
      getListIdsConnect,
      history,
      location,
    } = this.props;
    const { pathname } = location;
    const { id: value, name: label } = restaurant;
    handleChangeFiltersConnect(EnumPage.TABLE_MANAGEMENT.id, 'merchant', {
      value,
      label,
    });
    handleChangeFiltersConnect(
      EnumPage.TABLE_MANAGEMENT.id,
      'orderCode',
      notification.orderCode,
    );
    if (pathname !== typePushTable.to) {
      history.push(typePushTable.to);
    } else {
      getListIdsConnect();
    }
  };

  processNotificationShip = async (restaurant, bookingCode) => {
    const typePushOrder = EnumNotificationBell.SHIP;
    const {
      history,
      location,
      changeCurrentRestaurantConnect,
      openOrderNowShipDetailConnect,
    } = this.props;
    const { pathname } = location;
    if (pathname !== typePushOrder.to) {
      history.push(typePushOrder.to);
    }
    await changeCurrentRestaurantConnect(restaurant);
    openOrderNowShipDetailConnect(bookingCode);
  };

  toggleNotification = isOpen => {
    const { setViewedNotificationConnect } = this.props;
    if (isOpen === false) {
      setViewedNotificationConnect();
    }
    this.setState(prevState => ({
      isDropdownNotificationOpen: isEmpty(isOpen)
        ? !prevState.isDropdownNotificationOpen
        : isOpen,
    }));
  };

  render() {
    const {
      notificationBell,
      restaurants,
      merchantTableInfos,
      setRingBellConnect,
    } = this.props;
    const { isDropdownNotificationOpen } = this.state;
    const {
      listNotifications = [],
      isRingBell,
      ringBellSound,
    } = notificationBell;
    const totalNotification = listNotifications.length;
    const playStatus =
      isRingBell && totalNotification > 0
        ? Sound.status.PLAYING
        : Sound.status.STOPPED;
    const isLoop = ringBellSound !== EnumBellSound.NOW_SHIP_ASSIGN_TIMEOUT.id;
    return (
      <div className="noti">
        {!isEmptyObject(listNotifications) && (
          <React.Fragment>
            <span
              className="noti-bell"
              onClick={() => this.toggleNotification()}
            >
              <ReactSVG
                src={BellSvgIcon}
                wrapper="span"
                beforeInjection={(svg) => {
                  svg.setAttribute('style', `width: 24px;height:24px;color:rgba(0,0,0,0.65);`)
                }}
              />
              {totalNotification > 0 && (
                <span className="number-notification">{totalNotification}</span>
              )}
            </span>
            {isDropdownNotificationOpen &&
              <NotificationDropdown
                notificationBell={notificationBell}
                restaurants={restaurants}
                merchantTableInfos={merchantTableInfos}
                toggleNotification={this.toggleNotification}
                handleSelectNotification={this.handleSelectNotification}
              />
            }
          </React.Fragment>
        )}
        <Sound
          url={getBellSoundFile(ringBellSound)}
          playStatus={playStatus}
          loop={isLoop}
          onFinishedPlaying={() => {
            if (!isLoop) {
              setRingBellConnect(false);
            }
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  notificationBell: state.setting.notificationBell,
  restaurants: state.app.restaurants,
  merchantTableInfos: state.app.merchantTableInfos,
});

const mapDispatchToProps = dispatch => ({
  getListManagerOrderConnect: () => dispatch(getListManagerOrder()),
  getOrderDetailConnect: orderCode => {
    dispatch(getOrderDetail(orderCode));
    dispatch(setRingBell(false));
  },
  setCurrentRestaurantConnect: restaurant => {
    dispatch(setCurrentRestaurant(restaurant));
  },
  removeNotificationBellConnect: orderCode => {
    dispatch(removeNotificationBell({ orderCode }));
  },
  getListIdsConnect: () => dispatch(getListIds()),
  handleChangeFiltersConnect: (page, name, value) => {
    dispatch(changeFilters(page, name, value));
  },
  setViewedNotificationConnect: () => {
    dispatch(setViewedNotification());
  },
  changeCurrentRestaurantConnect: restaurant =>
    dispatch(changeCurrentRestaurantNowShip(restaurant)),
  openOrderNowShipDetailConnect: itemId => {
    dispatch(openDialogGeneric(EnumPage.NOW_SHIP_ORDER_MANAGEMENT.id, itemId));
  },
  setRingBellConnect: (res, ringBellSound) => {
    dispatch(setRingBell(res, ringBellSound));
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(NotificationBell),
);



// WEBPACK FOOTER //
// ./foody/src/layout/components/Header/components/NotificationBell.jsx